export default __webpack_public_path__ + "static/media/champion2.3af7525c.svg";